import { render, staticRenderFns } from "./PostulantDetails.vue?vue&type=template&id=07392b52&"
import script from "./PostulantDetails.vue?vue&type=script&lang=js&"
export * from "./PostulantDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports